export default {
  list(state) {
    return state.locations;
  },
  listCountry(state) {
    return state.countries;
  },
  listDestinations(state) {
    return state.destinations;
  },
};
